import 'alpinejs/dist/alpine-ie11';

import {initBackdrop} from './components/backdrop';
import {initNavigation} from './components/navigation';
import {initSliders} from './components/slider'
import {initFancybox} from './components/fancybox';
import {initPopUp} from './components/popup';
import {initMailto} from './components/mailto';
import {initReframe} from './components/reframe';

document.addEventListener('DOMContentLoaded', function () {
  initBackdrop();
  initNavigation();
  initSliders();
  initFancybox();
  initPopUp();
  initMailto();
  initReframe();
});
